var React = require("react");

var TwitterProfile = React.createClass({
  propTypes: {
    handle: React.PropTypes.string,
    profile_image_url: React.PropTypes.string,
    name: React.PropTypes.string,
    followers_count: React.PropTypes.number
  },
  render: function() {
    var profileURL = "https://twitter.com/" + this.props.handle;
    return (
      <div className="twitter-preview">
        <img className="twitter-profile-img" src={this.props.profile_image_url} />
        <div className="name">
          <a
            className="twitter-name"
            href={profileURL}
            title={`visit ${this.props.name}'s' Twitter account and follow it`}
            target="_blank"
            rel="noopener noreferrer">
            {this.props.name}
          </a>
        </div>
        <span className="followers-count">{this.props.followers_count} followers</span>
      </div>
    );
  }
});

module.exports = TwitterProfile



// WEBPACK FOOTER //
// ./src/components/twitter_profile.jsx